import { Dispatch } from 'redux';
import { actionCreators } from './ProductsState';
import { ArtifactPackageHashMap } from '../../Interfaces/ProductsManagement/ArtifactPackageHashMap';
import { ArtifactImportPayload } from '../../Interfaces/ProductsManagement/ArtifactImportPayload';

export const validateArtifactVersions = async (
  dispatch: Dispatch<any>,
  artifacts: ArtifactPackageHashMap[],
) => {
  return dispatch(actionCreators.validateArtifactVersions(artifacts));
};

export const registerArtifactsImport = async (
  dispatch: Dispatch<any>,
  sessionId: string,
  artifactImportPayload: ArtifactImportPayload,
) => {
  return dispatch(
    actionCreators.registerArtifactsImport(sessionId, artifactImportPayload),
  );
};

export const getProductPackagesVersions = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.getProductPackagesVersions());
};

export const activatePackageVersion = async (
  dispatch: Dispatch<any>,
  productPackageId: number,
) => {
  return dispatch(actionCreators.activatePackageVersion(productPackageId));
};

export const resetActivationFlags = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetActivationFlags());
};

export const getNodeDeploymentInfo = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.getNodeDeploymentInfo());
};

export const getProductPackagesHealthInfo = async (
  dispatch: Dispatch<any>,
  nodeId: number,
) => {
  return dispatch(actionCreators.getProductPackagesHealthInfo(nodeId));
};
